const FEATURE_FLAGS_KEY = 'featureFlags';

export interface FeatureFlags {
    useNewPdfVersion: boolean;
    cleoEnabled?: boolean;
    aiProviderClaude?: boolean;
    aiProviderOpenai?: boolean;
    patientManagementEnabled?: boolean;
    [key: string]: boolean | undefined;
}

const defaultFeatureFlags: FeatureFlags = {
    useNewPdfVersion: false,
    cleoEnabled: false,
};

/**
 * Salva as feature flags no localStorage
 */
export const setFeatureFlags = (flags: FeatureFlags): void => {
    localStorage.setItem(FEATURE_FLAGS_KEY, JSON.stringify(flags));
};

/**
 * Recupera as feature flags do localStorage
 */
export const getFeatureFlags = (): FeatureFlags => {
    const stored = localStorage.getItem(FEATURE_FLAGS_KEY);
    if (stored) {
        try {
            return { ...defaultFeatureFlags, ...JSON.parse(stored) } as FeatureFlags;
        } catch {
            return defaultFeatureFlags;
        }
    }
    return defaultFeatureFlags;
};

/**
 * Verifica se a nova versão de PDF está habilitada
 */
export const isNewPdfVersionEnabled = (): boolean => {
    return getFeatureFlags().useNewPdfVersion;
};

/**
 * Verifica se a Cleo está liberada pra este usuário
 */
export const isCleoEnabled = (): boolean => {
    return getFeatureFlags().cleoEnabled ?? false;
};

/**
 * Verifica se a Gestão de Pacientes está liberada pra este usuário
 */
export const isPatientManagementEnabled = (): boolean => {
    return getFeatureFlags().patientManagementEnabled ?? false;
};

/**
 * Remove as feature flags (usado no logout)
 */
export const clearFeatureFlags = (): void => {
    localStorage.removeItem(FEATURE_FLAGS_KEY);
};